import React from 'react';
import c from 'classnames';
import s from './SubLabel.scss';

interface Props {
  children: React.ReactNode;
  isDim?: boolean;
}

const SubLabel: React.FC<Props> = ({ children, isDim }) => {
  return <div className={c(s['root'], isDim && s['dim'])}>{children}</div>;
};
SubLabel.displayName = 'SubLabel';

export default SubLabel;
